<template>
  <VBtnToggle
      borderless
      group
      class="toggle-button-container flex-wrap my-0"
      :value="value"
      :mandatory="true"
      @change="newValue => $emit('change', newValue)"
  >
    <template v-for="(item, index) in items">
      <VTooltip
          :key="index"
          v-if="item.disabled"
          bottom
          nudge-width="100"
      >
        <template v-slot:activator="{ on }">
          <div v-on="on" class="d-flex align-center px-1">
            <VBtn
                class="mt-0 mb-3 mr-3 ml-0"
                :key="index"
                v-blur
                :value="item.value"
                :disabled="item.disabled || (disabled && item.value !== value)"
                rounded
                small
            >

              <span class="body-2">{{ item.text }}</span>
            </VBtn>
          </div>
        </template>
        <div v-for="(hint, index) in item.hints" :key="index">
          <span>{{ $t(hint) }}</span>
        </div>
      </VTooltip>
      <VBtn
          class="mt-0 mb-3 mr-3 ml-0"
          v-else
          :key="index"
          v-blur
          :disabled="item.disabled || (disabled && item.value !== value)"
          :value="item.value"
          rounded
          small
      >

        <span class="body-2">{{ item.text }}</span>
      </VBtn>
    </template>
  </VBtnToggle>
</template>

<script lang="ts">
export default {
  name: 'CustomBtnToggle',
};
</script>

<script setup lang="ts">
defineProps({
  value: String,
  items: {
    type: Array,
    required: true,
  },
  disabled: {
    type: Boolean,
    required: false,
  },
});
</script>

<style lang="scss" scoped>
</style>
